import React, {useState} from "react";
import "./Login.css";
import { Container, Button ,Form, Alert} from 'react-bootstrap';
import useBackend, { SpinnerX } from '../../services/useBackend_v2';
import {Sida,Rubrik,Stycke,ContentWrapper,Artickel} from "../ContentStyles";
import {Branding} from '../../services/misc';

export default function Info() {
  const { loading, resultVariant, resultVisible, resultText, Update, XCall } = useBackend('');
  const [PasswordResetGUID, setPasswordResetGUID] = useState(window.location.pathname.replace('/password/request/set/',''));

  async function handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData(e.target), formDataObj = Object.fromEntries(formData.entries());
    formDataObj.PasswordResetGUID = PasswordResetGUID;
    formDataObj.Test = "Data";

    const { errorsException } = await XCall('/backend/auth/password/request/set', 'POST', 3000, { SystemID: "NS", FormData: formDataObj }, true);
    
    // if (!errorsException) {
    // 	setTimeout(() => {
    // 		setModalshowAddDevice(false);
    // 		Refresh();
    // 	}, 2000);
    // }        
  }
    
  return (
    <ContentWrapper>
    <Container>
    <Sida>
    <Artickel>
        <Rubrik>Ange nytt lösenord</Rubrik>
        <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                  <Form.Label className="FormHeaderText">Password</Form.Label>
                  <Form.Control type="password" name="password" />
              </Form.Group>  

              <Form.Group className="mb-3">
                  <Form.Label className="FormHeaderText">Password</Form.Label>
                  <Form.Control type="password" name="password_validate" />
              </Form.Group>                      

              <Form.Group className="mb-3" hidden={!loading}>
                  <SpinnerX  />
              </Form.Group>                                      
                  
              <Form.Group className="mb-3" hidden={!resultVisible}>
                  <Alert variant={resultVariant} className="FormSpace">{resultText}</Alert> 
              </Form.Group>        

              <Form.Group className="mb-3">
                  <Button className="QmeButton" style={{backgroundColor:Branding().ButtonColor}} variant="primary" type="submit">Skicka</Button>
              </Form.Group>   
        </Form> 
    </Artickel>
    </Sida>
    </Container>
    </ContentWrapper>
  );
};